module.exports = __webpack_public_path__ + "static/media/rhythm-bot.fcc18198.png";